<template>
<div class="">

  <v-card-title class="secondary lighten-1 white--text pa-4" v-if="$store.getters['profile_view/isOwner']">
    <v-col cols="12" md="6" class="text-center text-md-left">
      <v-btn :small="$store.state.app.display ==='xs' || $store.state.app.display ==='sm'" rounded color="primary" to="/user/profile">Edit
        <v-icon :small="$store.state.app.display ==='xs' || $store.state.app.display ==='sm'" class="ml-2">fa-edit</v-icon>
      </v-btn>
    </v-col>
    <v-col cols="12" md="6" class="text-center text-md-right">
      <div>
        <a class="nolink" style="font-size:14px" target="_blank" :href="windowLocation">{{windowLocation}}</a>
        <br />
        <v-btn color="white" x-small text @click="copyLink">Copy to clipboard</v-btn>
      </div>
    </v-col>
  </v-card-title>


  <v-container fluid v-if="$store.state.profile_view.password_required" class="gradient fullscreen">
    <v-row justify="center" align="center">
      <v-card width="350" light>
        <v-card-title class="secondary white--text">Access Code Required
          <v-spacer></v-spacer>
          <v-icon dark>fa-lock</v-icon>
        </v-card-title>
        <v-container class="py-6">
          <v-row>
            <v-col cols="12">
              <v-text-field hide-details type="password" v-model="profile_password" outlined label="Code" v-on:keyup.enter="submitProfilePassword"></v-text-field>
            </v-col>
            <v-col cols="12" class="text-center" v-if="$store.state.profile_view.password_invalid">
              <h5 class="error--text">Invalid code</h5>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions class="grey lighten-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="submitProfilePassword" :loading="profile_loading">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>

  <v-container fluid class="pa-0">
    <div v-if="profile">
      <v-card-title class="secondary white--text">
        <v-col cols="0" md="2" class="d-none d-md-flex">
        </v-col>
        <v-col cols="12" md="8" class="text-center">
          <h2>{{profile.account.name}}</h2>
        </v-col>
        <v-col cols="12" md="2" class="text-center text-md-right">
          <v-chip dark v-if="profile.account.resume" color="blue">
            <a target="_blank" class="nolink white--text" :href="profile.account.resume">Resume</a>
          </v-chip>
        </v-col>
      </v-card-title>
      <v-container fluid>
        <v-row justify="center">
          <v-col cols="12" sm="6" md="6" lg="5" xl="4" v-if="$store.getters['profile_view/profileVideo'](1)">
            <v-hover v-slot:default="{ hover }">
              <v-card :elevation="hover ? 12 : 2" class="secondary">
                <v-card-actions class="secondary  white--text">
                  <v-col cols="12" class="text-center">
                    <h3>My Interests</h3>
                  </v-col>
                </v-card-actions>
                <v-divider dark></v-divider>
                <div class="video-responsive black">
                  <video :poster="$store.getters['profile_view/profileVideo'](1).thumbnail" controls>
                <source :src="$store.getters['profile_view/profileVideo'](1).url" type="video/mp4">
                <source :src="$store.getters['profile_view/profileVideo'](1).url" type="video/ogg">
                Your browser does not support HTML5 video.
                  </video>
                </div>

              </v-card>
            </v-hover>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="5" xl="4" v-if="$store.getters['profile_view/profileVideo'](2)">
            <v-hover v-slot:default="{ hover }">
              <v-card :elevation="hover ? 12 : 2" class="secondary">
                <v-card-actions class="secondary white--text">
                  <v-col cols="12" class="text-center">
                    <h3>My Work Experience</h3></v-col>
                </v-card-actions>
                <v-divider dark></v-divider>
                <!--
                <v-img :src="profile.video_2.thumbnail" class="clicky" @click="$eventBus.$emit('play_video',profile.video_2.url)">
                  <v-row class="lightbox white--text pa-2 fill-height">
                    <v-overlay :absolute="true" :value="true" :opacity="0.5">
                      <v-btn color="primary">
                        <v-icon small>fa-play</v-icon>
                      </v-btn>
                    </v-overlay>
                  </v-row>
                </v-img>
                !-->
                <div class="video-responsive black">
                  <video :poster="$store.getters['profile_view/profileVideo'](2).thumbnail" controls>
                <source :src="$store.getters['profile_view/profileVideo'](2).url" type="video/mp4">
                <source :src="$store.getters['profile_view/profileVideo'](2).url" type="video/ogg">
                Your browser does not support HTML5 video.
                  </video>
                </div>

              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-container>


      <v-container fluid class="" style="">

        <v-row align="center" justify="center" v-if="profile.published_projects.length">
          <v-col cols="12" lg="10" xl="8">
            <v-card>
              <v-card-actions class="secondary white--text">
                <v-col cols="12" class="text-left">
                  <h3>My Published Work</h3>
                </v-col>
              </v-card-actions>
              <v-container fluid>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="4" lg="4" xl="4" v-for="(project,i) in profile.published_projects" :key="i">
                    <project-tile-mobile :project="project" v-if="$store.state.app.display ==='xs' || $store.state.app.display ==='sm'"></project-tile-mobile>
                    <project-tile :project="project" v-else></project-tile>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>

        <v-row align="center" justify="center" class="mt-4 mb-4" v-if="profile.links.length">
          <v-col cols="12" lg="10" xl="8" class="text-center">
            <v-card>
              <v-card-actions class="secondary white--text">
                <v-col cols="12" class="text-left">
                  <h3>My Links</h3>
                </v-col>
              </v-card-actions>
              <v-container>
                <v-row justify="center" style="height:100px" align="center">
                  <v-col cols="2" sm="1" lg="1" v-for="(link,i) in profile.links" :key="i">
                    <v-hover v-slot:default="{ hover }">
                      <v-btn x-large :href="link.url" target="_blank" icon :elevation="hover? 12 : 0">
                        <v-icon x-large :color="$helpers.linkColor(link.url)">{{$helpers.linkIcon(link.url)}}</v-icon>
                      </v-btn>
                    </v-hover>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>

        <v-row align="center" justify="center" v-if="profile.account.support_visible">
          <v-col cols="12" lg="10" xl="8">
            <v-card>
              <v-card-actions class="secondary">
                <v-col cols="8" class="text-left">
                  <h3 class="white--text">Support</h3>
                </v-col>
                <v-col cols="4" class="text-right">
                  <v-btn icon dark @click="$eventBus.$emit('play_video',$store.state.app.tutorials.support['Description'])">
                    <v-icon>fa-question</v-icon>
                  </v-btn>
                </v-col>


              </v-card-actions>
              <v-card-actions>
                <v-chip @click="support(option)" class="ma-2 clicky" color="green" text-color="white" v-for="(option,i) in  $store.getters['app/supportOptions']" :key="i">
                  <v-avatar left class="white">
                    <v-icon small color="green">fa-dollar-sign</v-icon>
                  </v-avatar>
                  {{option}}
                </v-chip>
              </v-card-actions>
              <v-card-text class="pt-0">
                {{$store.state.app.support_description}}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-container>

</div>
</template>
<script>
import projectTile from "@/components/profile_view/project-tile"
import projectTileMobile from "@/components/profile_view/project-tile-mobile"


export default {
  name: "",
  data: () => ({
    loading: false,
    error: false,
    profile_password: '',
    profile_loading: false
  }),
  created() {

  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.loadProfile()
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.loadProfile()
    next()
  },
  components: {
    projectTile: projectTile,
    projectTileMobile: projectTileMobile
  },
  computed: {
    profile() {
      return this.$store.state.profile_view.profile
    },
    windowLocation() {
      return window.location.href
    }
  },
  methods: {
    async loadProfile() {
      if (this.$route.params.uid) {
        try {
          this.profile_loading = true
          await this.$store.dispatch('profile_view/load', this.$route.params.uid)
          this.profile_loading = false
        } catch (ex) {
          alert(ex.error)
        }
      } else {
        this.$router.push('/')
      }
    },
    copyLink() {
      this.$copyText(this.windowLocation)
    },
    submitProfilePassword() {
      this.profile_loading = true
      this.$store.commit('profile_view/set_password', this.profile_password)
      this.$store.dispatch('profile_view/load', this.$route.params.uid)
      this.profile_loading = false
    },
    pauseVideos() {
      try {
        Array.from(document.querySelectorAll("video")).forEach(v => {
          v.pause()
        })
      } catch (ex) {
        console.error(ex)
      }

    },
    support(option) {
      this.pauseVideos();
      this.$eventBus.$emit('support', {
        account_id: this.profile.account.id,
        option: option
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.gradient-bg {
    background: -webkit-gradient(linear, left top, left bottom, from(#0067f4), to(#2bdadd));
    background: linear-gradient(#0067f4 0%,#0067f4 50%, #2bdadd 100%);
}
.video-responsive {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
}
.video-responsive video {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
}
.gradient {
    background: #FC466B;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #3F5EFB, #FC466B);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #3F5EFB, #FC466B);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}
.fullscreen {
    height: 80vh;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    z-index: 100;
}
</style>
